import * as React from 'react'
import styled from 'styled-components'
import { ReactNode } from 'react'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: -15px;
`

type ChoiceButtonProps<T> = {
  items: T[]
  selectedItem?: T
  renderItem: (item: T, selected: boolean) => ReactNode
}

class ChoiceButton<T> extends React.Component<ChoiceButtonProps<T>> {
  render() {
    return (
      <Container>
        {this.props.items.map((item, index) => (
          <React.Fragment key={index}>{this.props.renderItem(item, item === this.props.selectedItem)}</React.Fragment>
        ))}
      </Container>
    )
  }
}

export default ChoiceButton
